import SearchContainer from "src/container/search";
import { Helmet } from "react-helmet-async";

const Search = () => {
  return (
    <>
      <Helmet>
        <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
        <meta name="description" content="내 종목은 텔레그램에서 어떤 평가를 받고 있을까? 텔레모아 종목검색하고 코멘트 한눈에 확인" />
      </Helmet>
      <SearchContainer />
    </>
  );
}

export default Search;
